import Highcharts from 'highcharts';

import { getAbbreviationFromScale, Scale, ThirdPartyModule } from '@oaknorth/util-intl';

/**
 * i18n module that updates the global highcharts language settings when the language is changed
 */
export const highchartsi18next: ThirdPartyModule = {
  type: '3rdParty',

  init(i18n) {
    i18n.on('languageChanged', (_) => {
      const localisedNumericAbbreviations = [Scale.THOUSAND, Scale.MILLION, Scale.BILLION, Scale.TRILLION].map(
        (scale) => getAbbreviationFromScale(scale)
      );
      Highcharts.setOptions({
        lang: {
          numericSymbols: localisedNumericAbbreviations,
        },
      });
    });
  },
};
